import React, { useState } from 'react';
import '../css/ValidateTicket.css'; // Importa il file CSS

function ValidateTicket() {
  const [formData, setFormData] = useState({
    email: '',
    firstname: '',
    lastname: '',
    city_ceramichine: '',
    phone: '',
    instagram: '',
    ticket: '',
    source_ceramichine: '',
    source_ceramichine_custom: '',
    consent_privacy: false,
    consent_marketing: false,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/api/ticket`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (data.status === 200) {
        setFormSubmitted(true);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="validate-ticket-container">
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_ASSETS_URL}/logo.png`} alt="Logo" className="logo" />
      </div>
      <h2 className={formSubmitted ? 'hidden' : 'title'}>Convalida Biglietto</h2>
      <h2 className={formSubmitted ? 'success-title' : 'hidden'}>Biglietto validato, buon divertimento!</h2>
      <h1 className={formSubmitted ? 'smile-title' : 'hidden'}>:)</h1>
      {!formSubmitted && (
        <form className="form" onSubmit={(e) => e.preventDefault()}>
          <label className="label" htmlFor="email">Email:</label>
          <input className="input" type="email" name="email" value={formData.email} onChange={handleChange} required />

          <label className="label" htmlFor="firstname">Nome:</label>
          <input className="input" type="text" name="firstname" value={formData.firstname} onChange={handleChange} required />

          <label className="label" htmlFor="lastname">Cognome:</label>
          <input className="input" type="text" name="lastname" value={formData.lastname} onChange={handleChange} required />

          <label className="label" htmlFor="city_ceramichine">Città:</label>
          <select className="select" name="city_ceramichine" value={formData.city_ceramichine} onChange={handleChange} required>
            <option value=""> </option>
            <option value="Brescia">Brescia</option>
            <option value="Bologna">Bologna</option>
            <option value="Firenze">Firenze</option>
            <option value="Milano">Milano</option>
            <option value="Padova">Padova</option>
            <option value="Torino">Torino</option>
            <option value="Treviso">Treviso</option>
            <option value="Trieste">Trieste</option>
            <option value="Verona">Verona</option>
            <option value="Vicenza">Vicenza</option>
            <option value="Altre">Altre</option>
          </select>

          <label className="label" htmlFor="phone">Cellulare:</label>
          <input className="input" type="tel" name="phone" value={formData.phone} onChange={handleChange} required />

          <label className="label" htmlFor="instagram">Instagram:</label>
          <input className="input" type="text" name="instagram" value={formData.instagram} onChange={handleChange} required />

          <label className="label" htmlFor="source_ceramichine">Come ci hai conosciuto:</label>
          <select className="select" name="source_ceramichine" value={formData.source_ceramichine} onChange={handleChange} required>
            <option value=""> </option>
            <option value="Instagram">Instagram</option>
            <option value="TikTok">TikTok</option>
            <option value="Google">Google</option>
            <option value="Amici">Amici</option>
            <option value="Altro">Altro</option>
          </select>
          {formData.source_ceramichine === 'Altro' && (
            <input className="input" type="text" name="source_ceramichine_custom" placeholder="Specifica Altro" value={formData.source_ceramichine_custom} onChange={handleChange} />
          )}

          <label className="label" htmlFor="ticket">Codice Biglietto:</label>
          <input className="input" type="text" name="ticket" value={formData.ticket} onChange={handleChange} required />

          <label className="checkbox-label">
            <input className="checkbox" type="checkbox" name="consent_privacy" checked={formData.consent_privacy} onChange={handleChange} required />
            <span>* Consenti al trattamento dei tuoi dati personali.</span>
          </label>

          <label className="checkbox-label">
            <input className="checkbox" type="checkbox" name="consent_marketing" checked={formData.consent_marketing} onChange={handleChange} />
            <span>Vuoi rimanere aggiornato sui prossimi eventi? Iscriviti alla newsletter.</span>
          </label>

          {loading ? (
            <div className="spinner-container">
              <div className="spinner"></div>
            </div>
          ) : (
            <button className="button" type="button" onClick={handleSubmit} disabled={loading}>
              Convalida
            </button>
          )}
        </form>
      )}
    </div>
  );
}

// Add spinner styles
const spinnerStyles = `
.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 2px solid #3498db;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;
}
`;

// Add keyframes for the spinner animation
const spinnerKeyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

// Add spinner container styles
const spinnerContainerStyles = `
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px; // Adjust height as needed
}
`;

// Inject spinner styles into the document
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(spinnerStyles, styleSheet.cssRules.length);
styleSheet.insertRule(spinnerKeyframes, styleSheet.cssRules.length);
styleSheet.insertRule(spinnerContainerStyles, styleSheet.cssRules.length);

export default ValidateTicket; 